import { Theme } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SwiperArrowButton = styled('button')(({ theme }: { theme: Theme }) => ({
  position: "relative",
  padding: ".5rem",
  backgroundColor: "#0d0f17",
  borderRadius: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "3px 3px 10px #1b57fee1",
  "&:after": {
    fontSize: ".7rem",
    fontWeight: "bold",
    color: "#4174ff",
  },
}));

export const SwiperContainer = styled('div')({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

export const SwipperArrow = styled('span')({
  fontSize: "1rem !important",
  color: "#235cff",
});

export const RightButton = styled(SwiperArrowButton)(({ theme }: { theme: Theme }) => ({
  left: "20px",
  [theme.breakpoints.down('md')]: {
    left: "0px",
  },
}));

export const LeftButton = styled(SwiperArrowButton)(({ theme }: { theme: Theme }) => ({
  right: "20px",
  [theme.breakpoints.down('md')]: {
    right: "0px",
  },
}));

export const SwiperSlideStyled = styled('div')({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
  "& img": {
    width: "100%",
  },
});
